import { ProjMath } from "./ProjMath.js";

///////////////////////////////////////////////////////////////////
///////MapMathUtils////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////
let MapMathUtils = function () { };
MapMathUtils.lerp = function (x, y, a) {
  return x * (1 - a) + y * a;
};
MapMathUtils.smoothstep = function (a, b, c) {
  let d = ProjMath.clamp((c - a) / (b - a), 0, 1);
  return d * d * (3 - 2 * d);
};
MapMathUtils.smootherstep = function (a, b, c) {
  let d = ProjMath.clamp((c - a) / (b - a), 0, 1);
  return d * d * d * (d * (6 * d - 15) + 10);
};
MapMathUtils.toUnitVector3d = function (lambda, phi) {
  let cosphi = Math.cos(phi);
  return [Math.cos(lambda) * cosphi, Math.sin(lambda) * cosphi, Math.sin(phi)];
};
MapMathUtils.slerp = function (from3dVec, to3dVec, intrpRatio) {
  //Spherical Linear Interpolation
  let d = ProjMath.clamp(from3dVec[0] * to3dVec[0] + from3dVec[1] * to3dVec[1] + from3dVec[2] * to3dVec[2], -1, 1);
  if (1 - ProjMath.EPSILON < d)
    return [(from3dVec[0] + to3dVec[0]) / 2, (from3dVec[1] + to3dVec[1]) / 2, (from3dVec[2] + to3dVec[2]) / 2];
  d < -(1 - ProjMath.EPSILON);
  let e = Math.acos(d),
    f = Math.sin(e),
    g = Math.sin((1 - intrpRatio) * e) / f,
    h = Math.sin(intrpRatio * e) / f;
  return [g * from3dVec[0] + h * to3dVec[0], g * from3dVec[1] + h * to3dVec[1], g * from3dVec[2] + h * to3dVec[2]];
};

///////////////////////////////////////////////////////////////////
///////Interpolater////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////
let Interpolater = function (currLPZ, targLPZ, timeSpan) {
  this.v1 = MapMathUtils.toUnitVector3d(currLPZ.lambda, currLPZ.phi);
  this.v2 = MapMathUtils.toUnitVector3d(targLPZ.lambda, targLPZ.phi);
  this.zoomStart = currLPZ.zoom;
  this.zoomEnd = targLPZ.zoom;
  this.timeSpan = timeSpan;
  this.startTime = null;
  this.finished = false;
};
Interpolater.create = function (currLPZ, targLPZ, timeSpan) {
    return new Interpolater(currLPZ, targLPZ, timeSpan); //);
};
Interpolater.prototype.getPos = function (currTime) {
  let tm = 0;
  if (null == this.startTime) this.startTime = currTime;
  else {
    let deltaTime = currTime - this.startTime;
    tm = ProjMath.clamp(deltaTime / this.timeSpan, 0, 1);
    this.startTime + this.timeSpan < currTime && (this.finished = true);
  }
  let intrpRatio = MapMathUtils.smootherstep(0, 1, tm);
  let currVec3d = MapMathUtils.slerp(this.v1, this.v2, intrpRatio);
  let currLP = ProjMath.toLambdaPhi(currVec3d);
  let currLPZ = {
    lambda: currLP.lambda,
    phi: currLP.phi,
    zoom: MapMathUtils.lerp(this.zoomStart, this.zoomEnd, tm), // this.zoomEnd, // 
  };
  return currLPZ;
};
Interpolater.prototype.isFinished = function () {
  return this.finished;
};

///////////////////////////////////////////////////////////////////
export { Interpolater };
